package dev.kotlinfest._2026.pages

internal data class Sponsor(
    val name: String,
    val logo: String,
    val heightPercent: Int = 60,
    val widthPercent: Int = 76,
    val url: String? = null,
)
internal data class SponsorPlan(val title: String, val columns: Int, val sponsors: List<Sponsor>)

internal val sponsorPlans = listOf(
    SponsorPlan(
        "ことり Plan",
        2,
        listOf(
            Sponsor("Sotas株式会社", "sotas.png", 60),
            // The supplied artwork already includes its clear space.
            Sponsor("株式会社ヘンリー", "henry.png", 80, widthPercent = 98, url = "https://henry.jp/"),
            Sponsor("株式会社ドワンゴ", "dwango.png", 60, url = "https://dwango.co.jp/"),
            Sponsor("LINEヤフー株式会社", "ly.png", 60, url = "https://www.lycorp.co.jp/ja/technology-design/"),
            Sponsor("株式会社asken", "asken.png", 60, url = "https://www.asken.inc/"),
            Sponsor("株式会社エス・エム・エス", "sms.png", 60, url = "https://www.bm-sms.co.jp/"),
        ),
    ),
    SponsorPlan(
        "Gold Plan",
        3,
        listOf(
            Sponsor("Gen-AX株式会社", "gen-ax.png", 60, url = "https://www.gen-ax.co.jp/"),
            Sponsor("株式会社コドモン", "codmon.png", 60, url = "https://www.codmon.co.jp/recruit/"),
            Sponsor("株式会社ネットプロテクションズ", "net-protections.png", 60),
            Sponsor("株式会社マネーフォワード", "money-forward.png", 90, widthPercent = 98, url = "https://corp.moneyforward.com/"),
            Sponsor("株式会社ニーリー", "nealle.svg", 46),
            Sponsor("Fairy Devices株式会社", "fairy-devices.png", 60, url = "https://fairydevices.jp/"),
            Sponsor("LINE Digital Frontier株式会社", "line-digital-frontier.svg", 60, url = "https://ldfcorp.com/ja"),
            Sponsor("株式会社ハイヤールー", "hireroo.png", 60, url = "https://hireroo.io/"),
            Sponsor("ディップ株式会社", "dip.png", 50, url = "https://recruit-dip.com/career/development/"),
        ),
    ),
    SponsorPlan(
        "Silver Plan",
        5,
        listOf(
            // Optical sizing accounts for aspect ratios and the artwork's built-in clear space.
            Sponsor("合同会社DMM.com", "dmm.png", 60, widthPercent = 82, url = "https://dmm-corp.com/"),
            Sponsor("Sansan株式会社", "sansan.png", 60, widthPercent = 72, url = "https://media.sansan-engineering.com/"),
            Sponsor("株式会社オプティム", "optim.png", 80, widthPercent = 82, url = "https://www.optim.co.jp/?utm_source=event&utm_medium=referral&utm_campaign=KotlinFest2026"),
            Sponsor("合同会社ザウエル", "zauel.svg", 60, widthPercent = 94, url = "https://zauel.co.jp/"),
            Sponsor("日本経済新聞社", "nikkei.png", 42, widthPercent = 82, url = "https://hack.nikkei.com/"),
        ),
    ),
)
